(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jh-blog-carousel"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('jh-blog-carousel'))customElements.define('jh-blog-carousel',class extends HTMLElement{
    connectedCallback(){
      this.cleanup?.();const abort=new AbortController(),signal=abort.signal;
      const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')],prev=this.querySelector('[data-prev]'),next=this.querySelector('[data-next]');
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      let active=panels.find(p=>!p.hidden),animations=[];
      const track=()=>active?.querySelector('.jh-blog__track');
      const update=()=>{const t=track();if(!t)return;prev.disabled=t.scrollLeft<=2;next.disabled=t.scrollLeft>=t.scrollWidth-t.clientWidth-2;prev.setAttribute('aria-controls',active.id);next.setAttribute('aria-controls',active.id)};
      const reveal=()=>{animations.forEach(a=>a.cancel());animations=[];if(reduced.matches||!active)return;active.querySelectorAll('.jh-blog__card').forEach((card,i)=>{if(i<4)animations.push(card.animate([{opacity:0,transform:'translateY(20px)'},{opacity:1,transform:'translateY(0)'}],{duration:450,delay:i*55,easing:'cubic-bezier(.2,.65,.3,1)'}))})};
      const select=(tab,focus=false)=>{tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1});panels.forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));active=panels.find(p=>!p.hidden);update();reveal();if(focus)tab.focus()};
      tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab),{signal});tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n],true)}},{signal})});
      const move=dir=>{const t=track(),card=t?.querySelector('.jh-blog__card');if(!card)return;const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(t).gap);t.scrollBy({left:step*dir,behavior:reduced.matches?'instant':'smooth'})};
      prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});
      const resize=new ResizeObserver(update);
      panels.forEach(p=>{const t=p.querySelector('.jh-blog__track');t.addEventListener('scroll',update,{signal,passive:true});t.addEventListener('keydown',e=>{if(e.target===t&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}},{signal});resize.observe(t)});
      this.addEventListener('shopify:block:select',e=>{const tab=tabs.find(t=>t.dataset.block===e.detail.blockId);if(tab)select(tab)},{signal});
      const observer=new IntersectionObserver(entries=>{if(entries[0].isIntersecting){reveal();observer.disconnect()}},{threshold:.1});observer.observe(this);
      update();this.cleanup=()=>{abort.abort();resize.disconnect();observer.disconnect();animations.forEach(a=>a.cancel())};
    }
    disconnectedCallback(){this.cleanup?.()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jh-exhibition-carousel"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('jh-exhibition'))customElements.define('jh-exhibition',class extends HTMLElement{
    connectedCallback(){
      this.cleanup?.();
      const abort=new AbortController(),signal=abort.signal;
      const track=this.querySelector('.jh-exhibition__track'),belt=this.querySelector('.jh-exhibition__belt'),group=this.querySelector('.jh-exhibition__group');
      if(!track||!group||!group.children.length)return;
      const reduced=matchMedia('(prefers-reduced-motion: reduce)');
      let offset=0,distance=0,frame=0,last=0,visible=false,selected=false,drag=null,blockClick=false,resumeAt=0;
      const speed=Number(this.dataset.speed)||30;
      const paint=()=>{
        if(!distance)return;
        offset=((offset%distance)+distance)%distance;
        belt.style.transform='translate3d('+(-offset)+'px,0,0)';
      };
      const measure=()=>{
        const old=distance,phase=old?offset/old:0;
        belt.querySelectorAll('[data-copy]').forEach(el=>el.remove());
        distance=group.getBoundingClientRect().width;
        if(!distance)return;
        const copies=Math.ceil(track.clientWidth/distance)+1;
        for(let i=0;i<copies;i++){
          const copy=group.cloneNode(true);
          copy.dataset.copy='true';copy.setAttribute('aria-hidden','true');
          [copy,...copy.querySelectorAll('*')].forEach(el=>{
            el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block');
            if(el.matches('a,button,[tabindex]'))el.setAttribute('tabindex','-1');
            if(el.matches('img')){el.draggable=false;el.loading='eager'}
          });
          belt.append(copy);
        }
        offset=phase*distance;track.dataset.ready='true';paint();
      };
      const tick=now=>{
        const dt=last?Math.min(now-last,64):0;last=now;
        const focused=this.contains(document.activeElement)&&document.activeElement.matches(':focus-visible');
        if(this.dataset.autoplay==='true'&&visible&&!document.hidden&&!reduced.matches&&!selected&&!drag&&!focused&&now>=resumeAt){offset+=speed*dt/1000;paint()}
        frame=requestAnimationFrame(tick);
      };
      const stopDrag=()=>{
        if(!drag)return;
        blockClick=drag.moved;drag=null;delete track.dataset.dragging;
        resumeAt=performance.now()+700;
      };
      track.addEventListener('pointerdown',e=>{
        if(e.button!==0)return;
        drag={id:e.pointerId,x:e.clientX,y:e.clientY,offset,moved:false};blockClick=false;
      },{signal});
      track.addEventListener('pointermove',e=>{
        if(!drag||e.pointerId!==drag.id)return;
        const dx=e.clientX-drag.x,dy=e.clientY-drag.y;
        if(!drag.moved&&Math.abs(dy)>Math.abs(dx)&&Math.abs(dy)>6){stopDrag();return}
        if(!drag.moved&&Math.abs(dx)>6){drag.moved=true;track.setPointerCapture(e.pointerId);track.dataset.dragging='true'}
        if(drag.moved){e.preventDefault();offset=drag.offset-dx;paint()}
      },{signal});
      window.addEventListener('pointerup',stopDrag,{signal});
      window.addEventListener('pointercancel',stopDrag,{signal});
      window.addEventListener('blur',stopDrag,{signal});
      track.addEventListener('click',e=>{if(blockClick){e.preventDefault();e.stopPropagation();blockClick=false}},{signal,capture:true});
      track.addEventListener('dragstart',e=>e.preventDefault(),{signal});
      track.addEventListener('wheel',e=>{
        const delta=e.deltaX||(e.shiftKey?e.deltaY:0);
        if(delta){e.preventDefault();offset+=delta;paint();resumeAt=performance.now()+700}
      },{signal,passive:false});
      track.addEventListener('keydown',e=>{
        if(e.target!==track)return;
        if(e.key==='ArrowRight'||e.key==='ArrowLeft'){
          e.preventDefault();offset+=(group.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(group).gap))*(e.key==='ArrowRight'?1:-1);paint();
        }
      },{signal});
      track.addEventListener('focusin',e=>{
        const card=e.target.closest('.jh-exhibition__card');
        if(card&&group.contains(card)){offset=card.offsetLeft-group.offsetLeft;track.scrollLeft=0;paint()}
      },{signal});
      this.addEventListener('shopify:block:select',e=>{
        selected=true;const card=e.target.closest('.jh-exhibition__card');
        if(card){offset=card.offsetLeft-group.offsetLeft;paint()}
      },{signal});
      const deselect=()=>{selected=false;resumeAt=performance.now()+700};
      this.addEventListener('shopify:block:deselect',deselect,{signal});
      this.addEventListener('shopify:section:deselect',deselect,{signal});
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;last=0});
      observer.observe(track);
      const resize=new ResizeObserver(measure);resize.observe(track);
      measure();frame=requestAnimationFrame(tick);
      this.cleanup=()=>{abort.abort();cancelAnimationFrame(frame);observer.disconnect();resize.disconnect();belt.querySelectorAll('[data-copy]').forEach(el=>el.remove());belt.style.transform='';delete track.dataset.ready;delete track.dataset.dragging};
    }
    disconnectedCallback(){this.cleanup?.()}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jh-project-context"]) return;
  try {
    
const jhSubjects={'style-adaptation':'Reimagine a JH style','original-design':'Develop my own design','collection-planning':'Plan a collection','showroom-visit':'Discuss a showroom visit'};
const jhRequested = new URLSearchParams(window.location.search).get('service');
if(jhSubjects[jhRequested]){const field=document.querySelector('select[name="contact[Development direction]"]');if(field){field.value=jhSubjects[jhRequested];field.dispatchEvent(new Event('change',{bubbles:true}));}}
document.addEventListener('click', event => {
const link=event.target.closest('a[href="#project-enquiry"]');
if(!link)return;
const form=document.querySelector('main form[action*="/contact"]');
if(!form)return;
event.preventDefault();
event.stopImmediatePropagation();
const heading=form.closest('.shopify-section');
const top=(heading || form).getBoundingClientRect().top+window.scrollY-110;
window.scrollTo({top:Math.max(0,top),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
history.replaceState(null,'',window.location.pathname+window.location.search+'#project-enquiry');
const first=form.querySelector('input:not([type="hidden"])');
if(first)first.focus({preventScroll:true});
},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jh-social-videos"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('jh-social-videos'))customElements.define('jh-social-videos',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;
      const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[role=tabpanel]')];
      const select=(tab,focus=false)=>{tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1});panels.forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));if(focus)tab.focus()};
      tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>select(tab),{signal});tab.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(i+1)%tabs.length;if(e.key==='ArrowLeft')n=(i+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();select(tabs[n],true)}},{signal})});
      this.addEventListener('shopify:block:select',e=>{const card=e.target.closest('[data-group]');if(card){select(tabs.find(t=>t.dataset.tab===card.dataset.group));card.scrollIntoView({block:'nearest',inline:'nearest'})}},{signal});
      const dialog=this.querySelector('dialog'),player=this.querySelector('.jh-social__player');
      this.querySelectorAll('[data-video-id]').forEach(link=>link.addEventListener('click',e=>{if(e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;e.preventDefault();const id=encodeURIComponent(link.dataset.videoId);const frame=document.createElement('iframe');frame.src=link.dataset.videoType==='youtube'?'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1':'https://player.vimeo.com/video/'+id+'?autoplay=1';frame.title=link.getAttribute('aria-label')||dialog.getAttribute('aria-label');frame.allow='autoplay; encrypted-media; picture-in-picture; fullscreen';frame.allowFullscreen=true;player.replaceChildren(frame);dialog.showModal()},{signal}));
      this.querySelector('.jh-social__close').addEventListener('click',()=>dialog.close(),{signal});
      dialog.addEventListener('close',()=>player.replaceChildren(),{signal});
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}},{signal});
    }
    disconnectedCallback(){this.abort?.abort();this.querySelector('.jh-social__player')?.replaceChildren()}
  });

  } catch(e) { console.error(e); }
})();
})();
